export type Calculator = "charging" | "range" | "session" | "warranty" | "fuel";
export function calculateTool(tool: Calculator, values: Record<string, string | number>, now = new Date()): Record<string, number | string> {
  const n = (key: string, min = 0, max = 1e8) => {
    const raw = values[key];
    const value = Number(raw);
    if (raw === undefined || String(raw).trim() === "" || !Number.isFinite(value) || value < min || value > max) throw new Error(key);
    return value;
  };
  if (tool === "charging") {
    const km = n("km", 1), use = n("use", .1, 100), ep = n("electricity"), fp = n("fuelPrice"), litres = n("litres", .1, 100);
    const ev = km / 100 * use * ep, fuel = km / 100 * litres * fp;
    return { ev, fuel, saving: fuel - ev, annual: (fuel - ev) * 12, ev100: use * ep, fuel100: litres * fp, km };
  }
  if (tool === "range") {
    const capacity = n("capacity", .1, 500), soh = n("soh", 1, 100), use = n("use", .1, 100);
    const speed = n("speed", 1, 250), temperature = n("temperature", -50, 60), climate = n("climate", 0, 30);
    const usable = capacity * soh / 100;
    const factor = (speed <= 60 ? 1.08 : speed <= 100 ? 1 : speed <= 120 ? .9 : .8) * (temperature < 0 ? .72 : temperature < 10 ? .84 : temperature > 32 ? .9 : 1) * (1 - climate / 100);
    const range = usable / use * 100 * factor;
    return { range, reserve: range * .85, usable, consumption: use / factor, low: range * .85, high: range * 1.1 };
  }
  if (tool === "session") {
    const capacity = n("capacity", .1, 500), start = n("start", 0, 100), end = n("end", 0, 100);
    const power = n("power", .1, 1000), price = n("price"), use = n("use", .1, 100), efficiency = n("efficiency", 1, 100) / 100;
    if (end <= start) throw new Error("end");
    const battery = capacity * (end - start) / 100, grid = battery / efficiency;
    return { battery, grid, loss: grid - battery, hours: grid / power, cost: grid * price, range: battery / use * 100, cost100: grid * price / (battery / use), start, end };
  }
  if (tool === "fuel") {
    const start = n("startKm"), end = n("endKm"), litres = n("volume", .1, 500), price = n("fuelPrice");
    if (end <= start) throw new Error("endKm");
    const distance = end - start, consumption = litres / distance * 100;
    return { distance, consumption, cost: litres * price, cost100: consumption * price, litres };
  }
  const first = String(values.first || "");
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(first)) throw new Error("first");
  const date = new Date(`${first}-01T12:00:00`);
  if (!Number.isFinite(date.getTime()) || date > now || date.getFullYear() < 1950) throw new Error("first");
  const years = n("years", 1, 30), limit = n("limit", 1), mileage = n("mileage");
  if (!Number.isInteger(years)) throw new Error("years");
  const endDate = new Date(date); endDate.setFullYear(date.getFullYear() + years);
  return { remainingKm: Math.max(0, limit - mileage), months: Math.max(0, Math.floor((endDate.getTime() - now.getTime()) / 2629800000)), expired: Number(endDate <= now || mileage >= limit), endDate: endDate.toISOString().slice(0, 10) };
}
